import { render, staticRenderFns } from "./FormTextArea.vue?vue&type=template&id=e3bea052&scoped=true&"
import script from "./FormTextArea.vue?vue&type=script&lang=ts&"
export * from "./FormTextArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3bea052",
  null
  
)

export default component.exports